import { typography } from "./typography"

export const radii = {
  ...typography.fontSizes,

  base: '0.5rem',
  none: "0",
  full: "9999px",
}